import { FC } from 'react';
import { AddInput } from '../../../../../../lib/components/AddInput';
import { ListFooter } from '../../../../../../lib/components/List/ListFooter';
import { usePartnerConfigForm } from '../../../hooks/usePartnerConfigForm';

interface IProps {
	on_added: (email: string) => void;
}

export const AddContractManagerInput: FC<IProps> = ({ on_added }) => {
	const { validators } = usePartnerConfigForm();

	return (
		<ListFooter>
			<AddInput
				{...{
					on_added,
					validate: validators.email,
				}}
			/>
		</ListFooter>
	);
};
